import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'
import yogaForBeginnersPng from '@/assets/landing/yoga_for_beginners.png'

const schema: LandingScreenSchema = {
	config: {
		background: 'base',
	},

	order: [
		'LandingLanguageButton',
		'LandingHead',
		'LandingTitle',
		'LandingSubtitle',
		'LandingImage',
		'LandingProgressLoader',
		'LandingFooter',
	],

	components: {
		LandingTitle: (): LandingComponentsConfig['LandingTitle'] => ({
			title: '15-MINUTE CHAIR YOGA FOR BEGINNERS',
			size: 'large',
		}),

		LandingSubtitle: (): LandingComponentsConfig['LandingSubtitle'] => ({
			title: 'Personalized for your <b>age & goals</b>',
			uppercase: true,
		}),

		LandingImage: (): LandingComponentsConfig['LandingImage'] => {
			return {
				img: yogaForBeginnersPng,
				customStyles: {
					height: '45vh',
					marginTop: '0rem',
				},
			}
		},

		LandingProgressLoader: (): LandingComponentsConfig['LandingProgressLoader'] => ({
			duration: 3500,
		}),
	},
}

export default schema
